export default {
  computed: {
    getMaxResults () {
      return this.variables.length > 1000 ? 30 : this.variables.length;
    }
  },
  methods: {
    onOk () {
      this.showModal = false;
    },
    onCancel () {
      this.showModal = false;
    },
    setTaggableVariables (taggableVariables) {
      this.taggableSelectedVariables = taggableVariables;
      this.taggableMultiselectKey += 1;
    },
    selectedTagsChanged (tags) {
      this.selectedTags = tags;
      this.$emit('tagsChanged', tags);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/explorer/variableSelectorMixin.js